import { SortingState } from '@tanstack/react-table';
import { DataEntriesSort } from 'general-ledger/fast-gl/types';

const dateSort: DataEntriesSort = { field: 'DATE_OF_TRANSACTION', direction: 'ASC' };
const vendorSort: DataEntriesSort = { field: 'VENDOR_NAME', direction: 'ASC' };
const amountSort: DataEntriesSort = { field: 'AMOUNT', direction: 'ASC' };
const amountMagnitudeSort: DataEntriesSort = { field: 'AMOUNT_MAGNITUDE', direction: 'ASC' };
const transferIdSort: DataEntriesSort = { field: 'TRANSFER_ID', direction: 'ASC' };

export const defaultMultiSort = [vendorSort, amountMagnitudeSort, amountSort, dateSort];
export const defaultMoneyInTransitSort = [
  transferIdSort,
  amountMagnitudeSort,
  amountSort,
  vendorSort,
  dateSort,
];

const getSortBy = (sorting: SortingState, defaultSort: DataEntriesSort[]) => {
  const sortBy: DataEntriesSort[] = [];
  sorting.map(sort => {
    const field = sort.id === 'transactionName' ? 'VENDOR_NAME' : 'DATE_OF_TRANSACTION';
    const direction = sort.desc ? 'DESC' : 'ASC';
    sortBy.push({ field, direction });
  });
  const remainingSortFields = defaultSort.filter(defaultSortItem => {
    return !sortBy.map(sort => sort.field).includes(defaultSortItem.field);
  });
  return [...sortBy, ...remainingSortFields];
};

export const getMultiSort = (sorting: SortingState) => {
  if (!sorting.length) return defaultMultiSort;
  return getSortBy(sorting, defaultMultiSort);
};

export const getMoneyInTransitSort = (sorting: SortingState) => {
  if (!sorting.length) return defaultMoneyInTransitSort;
  return getSortBy(sorting, defaultMoneyInTransitSort);
};
